import React from 'react';

import {UserStatus} from '@/entities/eployersControl/type';

import {StatusLabelStyled} from './styled';

export const StatusLabel = ({
    status,
    children,
}: {
    status: UserStatus;
    children: React.ReactNode;
}) => <StatusLabelStyled $status={status}>{children}</StatusLabelStyled>;
